import {Dispatch} from 'redux';
import {
  get,
  makeUrl,
} from '../../utils/fetcher';

import {
  METHODS,
} from '../../constants';
import {DomainLookupResult, CategoryHistoryResult, LookupHistory} from '../../types/Lookup';

export const lookupDomainCategories = (
  domain: string,
  // eslint-disable-next-line no-unused-vars
  callback: (result: DomainLookupResult) => void,
) => {
  const url = makeUrl(METHODS.LOOKUP_DOMAIN, {domain});
  return (dispatch: Dispatch) => get(url, dispatch)
    .then((response) => {
      if (response && response.data) {
        callback(response.data);
      }
    });
};

export const getDomainCategoryHistory = (
  domain: string,
  callback: (result: CategoryHistoryResult) => void,
) => {
  const url = makeUrl(METHODS.GET_DOMAIN_CATEGORY_HISTORY, {domain});
  return (dispatch: Dispatch) => get(url, dispatch)
    .then((response) => {
      if (response && response.data) {
        callback(response.data);
      }
    });
};

export const getRecentDomains = (
  // eslint-disable-next-line no-unused-vars
  callback: (result: LookupHistory) => void,
) => {
  const url = makeUrl(METHODS.GET_LOOKUP_HISTORY);
  return (dispatch: Dispatch) => get(url, dispatch)
    .then((response) => {
      if (response && response.data) {
        callback(response.data);
      }
    });
};
